import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String }

  connect() {
    const hasActiveLink = this.element.querySelector("a.bg-secondary") !== null

    if (hasActiveLink || localStorage.getItem(this.storageKey) === "true") {
      this.element.open = true
    }

    this.element.addEventListener("toggle", this.persist)
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.persist)
  }

  persist = () => {
    localStorage.setItem(this.storageKey, this.element.open)
  }

  get storageKey() {
    return `admin-menu-group:${this.keyValue}`
  }
}
